import * as _ from 'lodash';

var templateUrl = require('./sidebar-nav.html');

var navbarBreakpoint = 992;

angular.module('ciApp').component('sidebarNav', {
  templateUrl: templateUrl,
  controllerAs: '$sidebarNavCtrl',
  bindings: {
    opened: '='
  },
  controller: [
    '$rootScope',
    '$scope',
    '$window',
    'SiteSwitcherService',
    '$state',
    'classicUrl',
    'AuthService',
    SidebarNavController
  ]
});

function SidebarNavController(
  $rootScope,
  $scope,
  $window,
  SiteSwitcherService,
  $state,
  classicUrl,
  AuthService
) {
  var ctrl = this;

  ctrl.classicUrl = classicUrl;

  ctrl.watches = [];

  ctrl.$onInit = function() {
    ctrl.closeIfMobile();

    var user = AuthService.currentUser();

    if (user && user.isAdmin) {
      ctrl.adminNavOptions = [
        {
          name: 'Administrator',
          pages: [
            {
              name: 'Sites',
              routeName: 'admin.sites'
            },
            {
              name: 'Users',
              routeName: 'admin.users'
            },
            {
              name: 'Units',
              routeName: 'admin.epx-units'
            },
            {
              name: 'Report Schedules',
              routeName: 'admin.report-schedules'
            }
          ]
        }
      ];
    }

    ctrl.userNavOptions = [
      {
        name: 'EPX',
        pages: [
          {
            name: 'Reports',
            routeName: 'app.epx.reports({siteId: $sidebarNavCtrl.selectedSiteId})'
          },
          {
            name: 'Subscriptions',
            routeName: 'app.epx.subscriptions({siteId: $sidebarNavCtrl.selectedSiteId})'
          }
        ]
      }
    ];

    ctrl.setAvailableSites();

    function updateMySite(newSite) {
      ctrl.currentSite = newSite;
      ctrl.selectedSiteId = _.get(ctrl.currentSite, 'id');
    }

    updateMySite(SiteSwitcherService.currentSite());

    ctrl.watches.push($scope.$watch(SiteSwitcherService.currentSite, updateMySite, true));

    ctrl.watches.push($scope.$watch('$sidebarNavCtrl.opened', ctrl.closeIfMobile));

    $rootScope.$on('sitesUpdated', ctrl.setAvailableSites);

    angular.element($window).bind('resize', ctrl.closeIfMobile);
  };

  ctrl.setAvailableSites = function() {
    ctrl.availableSites = SiteSwitcherService.availableSites();
  };

  ctrl.getSiteName = function(siteId) {
    var currentSite = ctrl.currentSite;
    return currentSite ? currentSite.name : '';
  };

  ctrl.changeSite = function(siteId) {
    ctrl.opened = false;
    if (!_.isNil(siteId)) {
      ctrl.selectedSiteId = siteId;
    }
    SiteSwitcherService.changeSite(ctrl.selectedSiteId)
      .then(() => {
        return $state.go('app.epx.reports', { siteId: ctrl.selectedSiteId });
      })
      .catch(() => {
        /* did not actually change state, that's ok */
      });
  };

  ctrl.$onDestroy = function() {
    _.each(ctrl.watches, function(deregister) {
      deregister();
    });
  };

  ctrl.closeIfMobile = function() {
    if (ctrl.opened || $window.innerWidth > navbarBreakpoint - 1) {
      $('#sidebar-nav').removeClass('ng-hide');
    } else {
      $('#sidebar-nav').addClass('ng-hide');
    }
  };

  ctrl.isActiveRoute = function(routeName) {
    if (routeName.includes('(')) {
      routeName = routeName.substr(0, routeName.indexOf('('));
    }
    return routeName === $state.current.name;
  };
}



// WEBPACK FOOTER //
// ./common/components/sidebar-nav/sidebar-nav.component.js